// extracted by mini-css-extract-plugin
export default {"videoContainer":"style_videoContainer__zQ2PK","video":"style_video__LNL2M","android":"style_android__pTas1","text":"style_text__bP91r","container":"style_container__mNjwO"};